// src/components/Cards/CardEvent/CardEvent.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaPlaceOfWorship } from "react-icons/fa";
import { IoCalendarSharp } from "react-icons/io5";
import "./CardEvent.css";

import { formatDateRange } from "../../../utils/formatDate.js";
import { getChampionshipStateMeta } from "../../../utils/championshipState.js";

const CardEvent = ({ event }) => {
  const navigate = useNavigate();
  const stateMeta = getChampionshipStateMeta(event?.state);

  const handleClick = () => {
    navigate(`/campeonatos/${event.idchampionship}/list-categorias`);
  };

  return (
    <div
      className="relative flex w-full flex-col overflow-hidden rounded-lg bg-white shadow-md transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer dark:bg-neutral-700 md:h-60 md:flex-row card-event"
      onClick={handleClick}
    >
      <div className="h-48 w-full shrink-0 overflow-hidden bg-white md:h-full md:w-48 dark:bg-neutral-700">
        <img
          className="h-full w-full object-contain rounded-t-lg md:rounded-none md:rounded-l-lg"
          src={event.image_path}
          alt={event.name || "Imagen del evento"}
        />
      </div>
      <div className="flex flex-col justify-start p-6 w-full">
        <div className="mb-2 flex flex-wrap items-start justify-between gap-2">
          <h5 className="text-xl font-medium font-bold text-gray-700 dark:text-neutral-50">
            {event.name}
          </h5>
          <span
            className={`inline-flex shrink-0 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${stateMeta.className}`}
          >
            {stateMeta.label}
          </span>
        </div>
        <div className="flex items-center mb-2 text-neutral-600 dark:text-neutral-200">
          <FaPlaceOfWorship className="mr-2 text-blue-500" />
          <span>{event.place}</span>
        </div>
        <div className="flex items-center mb-4 text-neutral-600 dark:text-neutral-200">
          <IoCalendarSharp className="mr-2 text-green-500" />
          <span>{formatDateRange(event.startdate, event.enddate)}</span>
        </div>
      </div>
    </div>
  );
};

export default CardEvent;
